<section class="customers-list mt-4">
  <div class="clearfix">
    <h5 class="float-start mb-0">Klantenoverzicht</h5>
    <jbm-link-button class="float-end"
      [caption]="('ui.go-to'|translate) + ' ' + ('ui.the'|translate|lowercase) + ' ' + ('entity.customers'|translate)"
      iconClass="fa fa-arrow-right" (onClick)="showCustomers()">
    </jbm-link-button>
  </div>
  <div *ngIf="sortedCustomers.length; else noCustomers" class="table-responsive mt-2">
    <table class="table table-sm table-borderless w-auto mb-0">
      <thead>
        <tr>
          <td class="customer ps-0">Klant</td>
          <td class="w-4rem text-right">{{'entity.projects'|translate}}</td>
          <td class="w-7rem text-right">Productie</td>
          <td class="w-7rem text-right">Gefactureerd</td>
          <td class="w-7rem text-right">Openstaand</td>
          <td class="w-6rem text-right">Achterstallig</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of sortedCustomers; trackBy: trackByCustomerId">
          <td class="ps-0 customer">
            <jbm-link-button [caption]="customer.name" [showIcon]="false" class="me-1" (onClick)="showCustomer(customer.id)"></jbm-link-button>
            <div *ngIf="customer.blocked" class="badge bg-danger">{{'entity.blocked'|translate}}</div>
          </td>
          <td class="w-4rem text-right">{{customer.projectCount}}</td>
          <td class="w-7rem text-right">
            <jbm-inapplicable-value [value]="customer.productionAmount" [hideValue]="true"></jbm-inapplicable-value>
            <span *ngIf="customer.productionAmount">{{customer.productionAmount | float:2}} m<sup>3</sup></span>
          </td>
          <td class="w-7rem text-right">{{customer.invoicing.invoicedTotalPrice | money}}</td>
          <td class="w-7rem text-right">
            <jbm-inapplicable-value [value]="customer.invoicing.outstandingTotalPrice" [hideValue]="true"></jbm-inapplicable-value>
            <span *ngIf="customer.invoicing.outstandingTotalPrice">{{customer.invoicing.outstandingTotalPrice | money}}</span>
          </td>
          <td class="w-6rem text-right" [ngClass]="{'text-danger': customer.invoicing.overdueTotalPrice > 0}">
            {{customer.invoicing.overdueTotalPrice | money}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noCustomers>
    <jbm-empty-view [emptyView]="true"></jbm-empty-view>
  </ng-template>
</section>
